import { useEffect, useState } from 'react';

import { User, useAuth } from '../auth-factory';

function getStorageKey(context: string, user?: User) {
  return user ? [user.org_id, user.email, context].join('-') : context;
}

export function useStorageKey(context: string) {
  const { user } = useAuth();
  const [key, setKey] = useState(getStorageKey(context, user));

  useEffect(() => {
    if (user) {
      setKey(getStorageKey(context, user));
    }
  }, [context, user]);

  return key;
}
